/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_ue_mode_encode = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Encode`)
};

const es_ue_mode_encode = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Codificar`)
};

const de_ue_mode_encode = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kodieren`)
};

const nl_ue_mode_encode = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Coderen`)
};

const fr_ue_mode_encode = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Encoder`)
};

const it_ue_mode_encode = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Codifica`)
};

const pt_br2_ue_mode_encode = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Codificar`)
};

const pt_ue_mode_encode = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Codificar`)
};

const ja_ue_mode_encode = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`エンコード`)
};

const zh_ue_mode_encode = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`编码`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const ue_mode_encode = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.ue_mode_encode(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("ue_mode_encode", locale)
	if (locale === "en") return en_ue_mode_encode(inputs)
	if (locale === "es") return es_ue_mode_encode(inputs)
	if (locale === "de") return de_ue_mode_encode(inputs)
	if (locale === "nl") return nl_ue_mode_encode(inputs)
	if (locale === "fr") return fr_ue_mode_encode(inputs)
	if (locale === "it") return it_ue_mode_encode(inputs)
	if (locale === "pt-BR") return pt_br2_ue_mode_encode(inputs)
	if (locale === "pt") return pt_ue_mode_encode(inputs)
	if (locale === "ja") return ja_ue_mode_encode(inputs)
	return zh_ue_mode_encode(inputs)
};